import { VariationAction } from "../../../variations/actions/variation_action";
import { Analytics } from "./analytics";


export class ReviewValuerAnalytics extends Analytics {
  constructor() {
    super();
    VariationAction.REVIEW_USER_NAME_EVENT.on((data) => {
      this.run(() => {
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: 'レビューユーザー_バリエーション',
          club: {
            server: 'club/pc',
            prop5: 'レビューユーザー_バリエーション'
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', 'clkReviewUserVariation');
      });
    })
  }
}
